export default __webpack_public_path__ + "img/logo.9068b96f.svg";